import PropTypes from "prop-types"
import { useState } from "react"
import { useLocation } from "react-router-dom"
// @mui
import { Collapse, List, ListItem } from "@mui/material"
import { IsNavItemActive } from "event-definitions"
import { resolveValue } from "lib/resolve-as-function"
import { getActive, isExternalLink } from "./nav-helpers"
import NavItem from "./nav-item"

// ----------------------------------------------------------------------

NavList.propTypes = {
    data: PropTypes.object,
    depth: PropTypes.number,
    hasChildren: PropTypes.bool,
    isCollapse: PropTypes.bool,
}

export default function NavList({ data, depth, hasChildren, isCollapse = false }) {
    if (hasChildren === null || hasChildren === undefined) {
        hasChildren = !!data.children
    }
    const path = resolveValue(data.path)

    const location = useLocation()

    const { active } = IsNavItemActive.call({
        navItem: data,
        location,
        active: getActive(path, location.pathname, data.subPaths, location),
    })

    const [open, setOpen] = useState(active)
    const className = isExternalLink(path) ? "nav-item external" : "nav-item internal"

    if (data.content) {
        return (
            <ListItem component="li" disablePadding sx={{ display: "block" }}>
                <data.content.type
                    data={data}
                    depth={depth}
                    open={open}
                    active={active}
                    isCollapse={isCollapse}
                    onClick={handleClickItem}
                    {...data.content.props}
                />
            </ListItem>
        )
    }

    return (
        <ListItem component="li" disablePadding sx={{ display: "block" }}>
            <NavItem
                className={className}
                item={data}
                depth={depth}
                open={open}
                active={active}
                isCollapse={isCollapse}
                onClick={handleClickItem}
            />

            {!isCollapse && hasChildren && (
                <Collapse in={open} unmountOnExit>
                    <List component="ul" disablePadding>
                        <NavSubList data={data.children} depth={depth} />
                    </List>
                </Collapse>
            )}
        </ListItem>
    )

    function handleClickItem(event) {
        const result = data.subPaths?.onClick?.()
        if ((hasChildren && !isCollapse) || result === false) {
            event?.preventDefault()
        }
        setOpen(!open)
    }
}

// ----------------------------------------------------------------------

NavSubList.propTypes = {
    data: PropTypes.array,
    depth: PropTypes.number,
}

function NavSubList({ data, depth }) {
    return (
        <>
            {data.map((list) => (
                <NavList key={list.title + list.path} data={list} depth={depth + 1} hasChildren={!!list.children} />
            ))}
        </>
    )
}
